import { combineReducers } from 'redux';

import consultaToxicologico from './consultaToxicologico/reducer';

export default combineReducers({
	consultaToxicologico,
});
